import { CLIENT_VERSION } from "generated/clientVersion";

export const CLIENT_VERSION_CHECK_INTERVAL = 24 * 60 * 60 * 1000;

export function isNewerVersion(
  publishedVersion: string,
  currentVersion: string = CLIENT_VERSION,
): boolean {
  const publishedParts = publishedVersion.split(".").map(Number);
  const currentParts = currentVersion.split(".").map(Number);

  if (publishedParts.some(Number.isNaN) || currentParts.some(Number.isNaN)) {
    return false;
  }

  const partCount = Math.max(publishedParts.length, currentParts.length);
  for (let index = 0; index < partCount; index += 1) {
    const difference =
      (publishedParts[index] ?? 0) - (currentParts[index] ?? 0);
    if (difference !== 0) {
      return difference > 0;
    }
  }

  return false;
}

export async function fetchPublishedClientVersion(): Promise<string | null> {
  const publicUrl = process.env.PUBLIC_URL || "";
  const response = await fetch(
    `${publicUrl}/version.json?timestamp=${Date.now()}`,
    { cache: "no-store" },
  );

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return typeof data?.version === "string" ? data.version : null;
}
